import { createContext } from 'react';

const OrdersRecaptchaContext = createContext(null);

export default OrdersRecaptchaContext;
